import React from 'react';
import './Loading.css'

export default function Loading() {
    return (
        <div className = "loading">
            <h3>Processing your request ...</h3>
        </div>
    )
}